module.exports = __webpack_public_path__ + "static/media/contact.c6b91f17.jpg";